import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=c0ab67ca"
import script from "./DetailDialog.vue?vue&type=script&lang=js"
export * from "./DetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports